export const WIREGUARD_APP_STORE_URL =
  "https://apps.apple.com/app/wireguard/id1441195209";

export const WIREGUARD_DEEP_LINK = "wireguard://";

export const WIREGUARD_GUIDE_URL =
  "https://github.com/PhillipAlexanderYoung/knoxnet-browser-cam/blob/main/docs/wireguard-remote-camera.md";

export const DEFAULT_WIREGUARD_RECEIVER_URL = "wss://10.44.0.1:8787/ws";
